import { atom, selector } from "recoil";
import { getPlotTags, getSupportedCrops } from "./plot.service";
import { getDeviceTypes } from "./device.service";

export const userProfileState = atom({
    key: 'userProfileState',
    default: null
});

export const allUsersState = atom({
    key: 'allUsersState',
    default: []
});



export const cropTypesState = selector({
    key: 'cropTypesState',
    get: async ({ get }) => {
        try {
            const response = await getSupportedCrops();
            return response;
        } catch (err: any) {
            throw new Error(err);
        }
    },
});

export const deviceTypesState = selector({
    key: 'deviceTypesState',
    get: async ({ get }) => {
        try {
            const response = await getDeviceTypes();
            return response;
        } catch (err: any) {
            throw new Error(err);
        }
    },
});

export const plotTagsState = selector({
    key: 'plotTagsState',
    get: async ({ get }) => {
        try {
            const response = await getPlotTags();
            return response.map((i: any) => { return { id: i, name: i } });
        } catch (err: any) {
            throw new Error(err);
        }
    },
});